"use client";
import React from "react";
import YouTube from "./YouTube";
import * as styles from "../styles/video.module.scss";

const Video = (props) => {
	const { url, title } = props;
	return (
		<YouTube
			videoId={url} 
			rel="0"
			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen 
			className={styles.iframe}
			poster="maxresdefault"
			title={title ?? "videof"}
			webp={true}
		/>
	);
};

export default Video;
